import {
  Button,
  ButtonGroup,
  H2,
  Modal,
  TextInput,
} from "@datapay-by-datacom/design-system";
import { useState } from "react";
import s from "./CreateGroupModal.module.css";

interface CreateGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (name: string, description?: string) => void;
  isPending: boolean;
}

export function CreateGroupModal({
  isOpen,
  onClose,
  onCreate,
  isPending,
}: CreateGroupModalProps) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleCreate = () => {
    if (!name.trim()) return;
    onCreate(name.trim(), description.trim() || undefined);
  };

  const handleClose = () => {
    setName("");
    setDescription("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <div className={s.modal}>
        <H2>Create Group</H2>
        <p className={s.description}>
          Create a new user group to organize users and manage org access in
          bulk.
        </p>

        <div className={s.field}>
          <TextInput
            label="Group Name"
            value={name}
            onChange={setName}
            isDisabled={isPending}
          />
        </div>

        <div className={s.field}>
          <TextInput
            label="Description (optional)"
            value={description}
            onChange={setDescription}
            isDisabled={isPending}
          />
        </div>

        <ButtonGroup>
          <Button
            variant="tertiary"
            onPress={handleClose}
            isDisabled={isPending}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onPress={handleCreate}
            isDisabled={!name.trim() || isPending}
          >
            {isPending ? "Creating..." : "Create Group"}
          </Button>
        </ButtonGroup>
      </div>
    </Modal>
  );
}
